import CommonForm, { ItemElementPropsInterface } from '../../../../../../components/common/common-form/common-form'
import { Button, DatePicker, Input, InputNumber, Switch } from 'antd'
import { commonFormSelect, getSelectOptions } from '../../../../../../components/common/common-form/common-form-select'
import { ApiRequest } from '../../../../../../services/api/api'
import { urlKey, urlType } from '../../../../../../services/api/api-urls'
import React, { useEffect, useState } from 'react'
import SweetAlertService from '../../../../../../services/lib/utils/sweet-alert-service'
import moment from 'moment'
import { getCookie } from 'react-use-cookie'
import { addWorkdaysWithHolidays } from '../../../../../../services/others/holiday-services'

interface IFormValues {
  customerId?: any
  employeeId?: any
  baseProductRoutingId?: any
  workOrderSourceId?: any
  productId?: any
  quantity?: any
  comments?: any
  commentType?: boolean
  urgent?: any
  requiredDate?: any
  enableOrderQty?: any
  orderQty?: any
}

const WorkOrderAddDialog = (props: {onDialogClose: any, isStockMonitor?: boolean}) => {
  const [formRef, setFormRef] = useState<any>()
  const [initFormValues, setInitFormValues] = useState<IFormValues>()

  // store selection options from apis request
  const [customerOptions, setCustomerOptions] = useState([])
  const [employeeOptions, setEmployeeOptions] = useState([])
  const [baseProductRoutingOptions, setBaseProductRoutingOptions] = useState<any[]>([])
  const [workOrderSourceOptions, setWorkOrderSourceOptions] = useState([])
  const [productsOptions, setProductsOptions] = useState([])
  const [qtyPreCarton, setQtyPreCarton] = useState(null)

  useEffect(() => {
    const initForm = async () => {
      // console.log(props.orderData)
      // debugger
      // Use holiday-aware calculation for default required date (10 working days)
      const defaultReqDate = await addWorkdaysWithHolidays(new Date(), 10)
      setInitFormValues({
        workOrderSourceId: props.isStockMonitor ? 3 : 2,
        baseProductRoutingId: null, // 初始为null，会在选择产品后获取
        requiredDate: moment(defaultReqDate),
      })
      getSelectOptions(urlKey.Customer).then(res => setCustomerOptions(res))
      getSelectOptions(urlKey.Employee).then(res => setEmployeeOptions(res))
      // 移除全局的BaseProductRouting获取，改为在产品选择时获取
      getSelectOptions(urlKey.WorkOrderSource).then(res => setWorkOrderSourceOptions(res))
      getSelectOptions('', 'Product/GetAllProduct?withOutStock=true').then(res => setProductsOptions(res))
    }
    initForm()
  }, [])

  const [enableOrderQty, setEnableOrderQty] = useState(false)
  const [orderQty, setOrderQty] = useState(1)

  const formItems: ItemElementPropsInterface[] | any = [
    // {name: 'customerId', label: 'Customer', rules: [{required: false}], inputElement: commonFormsSelect(urlKey.Customer, customerOptions, ['company', 'customerCode'])},
    // {name: 'employeeId', label: 'Sales', inputElement: commonFormsSelect(urlKey.Employee, employeeOptions, ['firstName', 'lastName'], true)},
    {name: 'productId', label: 'Product', rules: [{required: true}], inputElement: commonFormSelect(urlKey.Product, productsOptions)},
    {name: 'quantity', span:6 , label:  `Quantity${qtyPreCarton ? ` [Pre Carton: ${qtyPreCarton}]` : ""}`, rules: [{required: true, type: 'number', min: 0}], inputElement: <InputNumber />},
    {name: 'baseProductRoutingId', label: 'Routing', rules: [{required: true}], inputElement: commonFormSelect('baseProductRouting', baseProductRoutingOptions, ['productTypeName'], false, undefined, 'id')},
    {name: 'workOrderSourceId', label: 'Order Source', inputElement: commonFormSelect(urlKey.WorkOrderSource, workOrderSourceOptions, [], true)},
    {name: 'requiredDate', label: 'REQ Date', rules: [{required: true}], inputElement: <DatePicker format={'YYYY-MM-DD'} showTime={{defaultValue: moment(), use12Hours: true, format: 'HH'}} />},
    {name: 'urgent', inputElement: <Switch />, otherProps: {valuePropName: 'checked'}},
    {name: 'comments', span: 5, label: 'Comment', inputElement: <Input.TextArea showCount={true} maxLength={150} autoSize={ true } />},
    {name: 'commentType', span: 1, label: 'type', inputElement: <Switch checkedChildren={'Sp'} unCheckedChildren={'Reg'} />, otherProps: {valuePropName: 'checked'}},
    {name: 'enableOrderQty', label: 'Allow Multiple Work Orders', inputElement: <Switch checked={enableOrderQty} onChange={e => setEnableOrderQty(e)} />, otherProps: {valuePropName: 'checked'}},
    {name: 'orderQty', label: 'Number of Work Orders', rules: [{required: enableOrderQty, type: 'number', min: 1, max: 50}], inputElement: <InputNumber value={ orderQty }  disabled={!enableOrderQty} />},
  ]

  const onFormChange = (changedValues: any, newValues: any, form: any) => {
    // console.log(changedValues)
    // console.log(newValues)
    const changedValuesKey = Object.keys(changedValues)[0]
    switch (changedValuesKey) {
      case 'customerId':
        if (!changedValues['customerId']) {
          getSelectOptions('', 'Product/GetAllProduct?withOutStock=true').then(res => setProductsOptions(res))
          return
        }
        if (changedValues['customerId']) {
          setCustomerInfosToForm(changedValues['customerId'], newValues, form)
          return
        }
        break
      case 'productId':
        if (changedValues['productId']) {
          setProductInfosToForm(changedValues['productId'], newValues, form)
          return
        }
        break
    }
  }

  const setProductInfosToForm = async (productId: any, newValues: any, form: any) => {
    const result = await ApiRequest({
      urlInfoKey: urlKey.Product,
      type: urlType.GetById,
      dataId: productId,
      isShowSpinner: false
    })
    if (result) {
      const productInfos = result.data.data
      setQtyPreCarton(productInfos.baseProduct.packagingType.quantity)

      // 获取产品的baseProductId
      const baseProductId = productInfos.baseProduct?.baseProductId

      let routingOptions: any[] = [] // 声明在更大作用域中

      // 如果产品有baseProductId，获取对应的routing选项
      if (baseProductId) {
        try {
          const routingResult = await ApiRequest({
            otherUrl: `BaseProductRouting/GetByBaseProductId?baseProductId=${baseProductId}`,
            method: 'get',
            isShowSpinner: false
          })

          if (routingResult && routingResult.data) {
            console.log('Routing API result:', routingResult)
            console.log('Routing result.data:', routingResult.data)
            console.log('Routing result.data.data:', routingResult.data.data)
            routingOptions = Array.isArray(routingResult.data.data) ? routingResult.data.data : []
            console.log('Setting routing options:', routingOptions)
            console.log('First routing option structure:', routingOptions[0])
            setBaseProductRoutingOptions(routingOptions)
          }
        } catch (error) {
          console.error('Failed to fetch routing options:', error)
          setBaseProductRoutingOptions([])
        }
      } else {
        // 如果产品没有baseProductId，清空routing选项
        setBaseProductRoutingOptions([])
      }

      const updatedValues = {
        ...newValues,
        // quantity: productInfos.baseProduct.packagingType.quantity
      }
      form.setFieldsValue(updatedValues)

      // 在设置所有表单值之后，设置默认routing（避免被覆盖）
      if (routingOptions.length > 0) {
        const defaultOption = routingOptions.find((item: any) => item.isDefault === true)
        if (defaultOption) {
          console.log('Setting default routing after form update:', defaultOption)
          form.setFieldsValue({
            baseProductRoutingId: defaultOption.id
          })
        }
      }
    }
  }

  const setCustomerInfosToForm = async (customerId: any, newValues: any, form: any) => {
    getSelectOptions('', 'Product/GetProductByCustomerId?id=' + customerId).then(res => setProductsOptions(res))
    const result = await ApiRequest({
      urlInfoKey: urlKey.Customer,
      type: urlType.GetById,
      dataId: customerId,
      isShowSpinner: false
    })
    if (result) {
      const customerInfos = result.data.data
      const updatedValues = {
        ...newValues,
        customerId: customerInfos.customerId,
        employeeId: customerInfos.employeeId,
        productId: null,
      }
      form.setFieldsValue(updatedValues)
    }
  }

  const onFormBlur = (form: any) => {
    // console.log(form.getFieldsValue())
    if (!formRef) {
      setFormRef(form)
    }
  }

  const onConfirm = async () => {
    const employeeId = parseInt(getCookie('id'))
    formRef.submit()
    const formValues: IFormValues = await formRef.validateFields()
    if (formValues) {
      // console.log(formValues)
      const requestValues = {
        ...formValues,
        urgent: formValues.urgent ? 1 : 0,
        commentType: formValues.commentType ? 'Special' : 'Regular',
        workOrderStatusId: 1,
        createdEmployeeId:employeeId,
        approvedEmployeeId:employeeId
      }
      let result
      if (enableOrderQty) {
        let orderQty = formValues.orderQty
        result = await ApiRequest({
          url: `WorkOrder/AddMultiWorkOrder/${orderQty}`,
          type: urlType.Create,
          data: requestValues
        })
      }else {
        result = await ApiRequest({
          urlInfoKey: urlKey.WorkOrder,
          type: urlType.Create,
          data: requestValues
        })
      }
      // console.log(requestValues)

      if (result) {
        // console.log(result)
        await SweetAlertService.successMessage('Submit successfully')
        props.onDialogClose(true)
      }
    }
  }

  return (
    <div style={ {width: '97%', margin: '0 auto 1rem'} }>
      <CommonForm items={formItems} onFormChange={onFormChange} onFormBlur={onFormBlur} initFormValues={initFormValues} />
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Button
          onClick={() => {
            props.onDialogClose(false)
          }}
          style={{marginRight: '2rem'}}
        >Cancel</Button>
        <Button
          disabled={!formRef}
          onClick={onConfirm}
          type="primary"
        >Confirm</Button>
      </div>
    </div>
  )
}

export default WorkOrderAddDialog
